// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/announcement/AnnouncementTicker.css
// module id = 869
// module chunks = 0